import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { currentUserInfo } from 'atoms';
import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import {
  modifyMyPhone,
  requestSmsToken,
  verifyPhoneNumber,
  verifySmsToken,
} from 'fetchers';
import ModifyButton from './ModifyButton';

const ModifyChangeCellPhoneNumber = ({ setIsOpen }) => {
  const [phone, setPhone] = useState('');
  const [authNumber, setAuthNumber] = useState('');
  const [isEnter, setIsEnter] = useState(false);
  const [isAuth, setIsAuth] = useState(false);

  const {
    apt: { id },
    user: { no },
  } = useRecoilValue(currentUserInfo);

  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();

  const modifyMutation = useMutation(() => modifyMyPhone(phone, no), {
    onSuccess: (data) => {
      queryClient.refetchQueries();
      enqueueSnackbar('핸드폰번호 변경에 성공하였습니다');
      setIsEnter((prev) => !prev);
      setIsOpen((prev) => !prev);
    },
    onError: () =>
      enqueueSnackbar('핸드폰번호 변경을 실패했습니다. 다시 시도해주세요'),
  });

  const handleInput = (e, type) => {
    const {
      target: { value },
    } = e;

    if (type === 'phone' && value.length <= 11) {
      setPhone(value);
    } else if (type === 'auth' && value.length <= 6) {
      setAuthNumber(value);
    }
  };

  const handleRequestSmsToken = async () => {
    const response = await requestSmsToken(id, phone);

    if (response) {
      setIsEnter(true);
    }
  };

  const handleVerifySmsToken = async () => {
    const response = await verifySmsToken(phone, authNumber);

    response ? setIsAuth(true) : setIsAuth(false);
  };

  const validateExistPhoneNumber = async () => {
    const response = await verifyPhoneNumber('FD0358', phone);

    return response ? true : false;
  };

  const handleSubmit = async () => {
    if (isAuth) {
      const validate = validateExistPhoneNumber();

      if (!validate) {
        enqueueSnackbar('이미 존재하는 번호입니다.');
      } else {
        if (isAuth) {
          modifyMutation.mutate();
        } else {
          enqueueSnackbar('인증번호를 다시 확인해주세요');
        }
      }
    } else {
      enqueueSnackbar('인증번호를 다시 확인해주세요');
    }
  };

  if (authNumber.length === 6) {
    handleVerifySmsToken();
  }

  return (
    <ModifyChangeCellPhoneNumberConatiner className='bg-gray-100'>
      <ModifyChangeCellPhoneNumberAuthContainer className='px-2 px-sm-3'>
        <ModifyChangeCellPhoneNumberInputContainer className='d-flex align-items-center justify-content-between'>
          <ModifyChangeCellPhoneNumberInput
            className='w-sm-75 form-control pl-2 mr-2 ml-sm-0'
            placeholder='변경할 번호를 입력해주세요'
            onChange={(e) => handleInput(e, 'phone')}
            value={phone}
          />
          <ModifyChangeCellPhoneNumberAuthButton
            className='btn btn-primary text-nowrap'
            onClick={handleRequestSmsToken}
          >
            인증번호
          </ModifyChangeCellPhoneNumberAuthButton>
        </ModifyChangeCellPhoneNumberInputContainer>
        {isEnter && (
          <ModifyChangeCellPhoneNumberInput
            className='form-control pl-2'
            placeholder='인증번호를 입력해주세요.'
            onChange={(e) => handleInput(e, 'auth')}
            value={authNumber}
            style={{ width: '100%', marginBottom: 20 }}
            inputMode='decimal'
            pattern='[0-9]*'
          />
        )}
      </ModifyChangeCellPhoneNumberAuthContainer>

      <ModifyButton handleSubmit={handleSubmit} />
    </ModifyChangeCellPhoneNumberConatiner>
  );
};

const ModifyChangeCellPhoneNumberConatiner = styled.section``;
const ModifyChangeCellPhoneNumberAuthContainer = styled.section``;
const ModifyChangeCellPhoneNumberAuthButton = styled.button`
  height: 48.5px;
`;
const ModifyChangeCellPhoneNumberInputContainer = styled.section`
  height: 84px;
`;
const ModifyChangeCellPhoneNumberInput = styled.input`
  height: 48.5px;
`;

export default ModifyChangeCellPhoneNumber;
